import { CommonModule, NgOptimizedImage } from '@angular/common';
import { NgModule } from '@angular/core';

import { AutomationModule } from '@frontend/sports/automation/core-feature';
import { FontResizerComponent } from '@frontend/sports/common/core/feature/font-resizer';
import { ScrollAdapterComponent } from '@frontend/sports/common/core/feature/scroll-adapter';
import { ToCssUrlPipe } from '@frontend/sports/common/core/utils/css-formatters';
import { TrustPipe } from '@frontend/sports/common/core/utils/dom';
import { CompetitionLogoComponent } from '@frontend/sports/competition-logos/feature';
import { ItemComponent } from '@frontend/sports/item/feature';
import { NativePriceFormatterPipe } from '@frontend/sports/odds/feature/native-price';
import { ParticipantImageComponent } from '@frontend/sports/participant-image/feature';
import { DsTouchClickDirective } from '@frontend/ui/shared';
import { SpeculativeLinkDirective } from '@frontend/vanilla/features/speculative-link';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';
import { RxFor } from '@rx-angular/template/for';

import { BetBuilderOverlayHeaderComponent } from '../bet-builder/components/bet-builder-overlay-header/bet-builder-overlay-header.component';
import { ScoreboardTimeComponent } from '../card-scoreboards/scoreboard-time.component';
import { ScoreboardComponent } from '../card-scoreboards/scoreboard.component';
import { ShowInEpcotDirective } from '../common/epcot-config.directive';
import { BadgeComponent } from '../crm-promotion/badge.component';
import { CrmPromotionModule } from '../crm-promotion/crm-promotion.module';
import { DirectivesModule } from '../directives/directives.module';
import { DropdownModule } from '../dropdown/dropdown.module';
import { NavigationCoreModule } from '../navigation-core/navigation-core.module';
import { OddIncrementDecrementComponent } from '../odd-increment-decrement/odd-increment-decrement.component';
import { BetBuilderGroupPickComponent } from '../option-pick/betbuilder-group-pick.component';
import { BetBuilderPickComponent } from '../option-pick/betbuilder-pick.component';
import { EventPickComponent } from '../option-pick/event-pick.component';
import { LcpCandidateDirective } from '../perf-cdk/lcp-candidate.directive';
import { PriceboostCountSignpostComponent } from '../shared-priceboost/components/priceboost-count-signpost.component';
import { TimerModule } from '../timers/timer.module';
import { BetBuilderCardComponent } from './bet-builder-card.component';
import { CorrectScoreCardComponent } from './correct-score-card.component';
import { GhostLoaderComponent } from './ghost-loader.component';
import { HeaderComponent } from './header.component';
import { HighlightsMarqueeComponent } from './highlights-marquee.component';
import { HighlightsRegularCardComponent } from './highlights-regular-card.component';
import { HighlightsSpecialCardComponent } from './highlights-special-card.component';
import { BetNowButtonComponent } from './option-group/bet-now-button.component';
import { OptionGroupComponent } from './option-group/option-group.component';
import { OutrightsMarqueeCardComponent } from './outrights-marquee-card.component';
import { OutrightsMarqueeWidgetComponent } from './outrights-marquee-widget.component';
import { OutrightsMarqueeComponent } from './outrights-marquee.component';
import { SixpackOptionGroupComponent } from './six-pack/option-group/six-pack-option-group.component';
import { SixPackOptionComponent } from './six-pack/option-group/six-pack-option.component';
import { SixPackEventComponent } from './six-pack/six-pack-event.component';
import { SpecialMarqueeBadgeComponent } from './special-marquee-badge.component';

@NgModule({
    declarations: [
        BetBuilderCardComponent,
        HighlightsMarqueeComponent,
        OutrightsMarqueeComponent,
        OutrightsMarqueeCardComponent,
        OutrightsMarqueeWidgetComponent,
        HighlightsRegularCardComponent,
        HighlightsSpecialCardComponent,
        GhostLoaderComponent,
        BetNowButtonComponent,
        SpecialMarqueeBadgeComponent,
        CorrectScoreCardComponent,
        SixPackEventComponent,
        SixPackOptionComponent,
        SixpackOptionGroupComponent,
        HeaderComponent,
    ],
    exports: [
        BetBuilderCardComponent,
        HighlightsMarqueeComponent,
        OutrightsMarqueeComponent,
        OutrightsMarqueeCardComponent,
        OutrightsMarqueeWidgetComponent,
        HighlightsRegularCardComponent,
        HighlightsSpecialCardComponent,
        GhostLoaderComponent,
        BetNowButtonComponent,
        OptionGroupComponent,
        SpecialMarqueeBadgeComponent,
        CorrectScoreCardComponent,
        SixPackEventComponent,
        SixPackOptionComponent,
        SixpackOptionGroupComponent,
        HeaderComponent,
    ],
    imports: [
        AutomationModule,
        CommonModule,
        OptionGroupComponent,
        OddIncrementDecrementComponent,
        DirectivesModule,
        NavigationCoreModule,
        EventPickComponent,
        BetBuilderPickComponent,
        TimerModule,
        ParticipantImageComponent,
        CrmPromotionModule,
        DropdownModule,
        CompetitionLogoComponent,
        NgOptimizedImage,
        ShowInEpcotDirective,
        ItemComponent,
        FontResizerComponent,
        TrustPipe,
        ScrollAdapterComponent,
        BadgeComponent,
        BetBuilderGroupPickComponent,
        RxFor,
        PriceboostCountSignpostComponent,
        BetBuilderOverlayHeaderComponent,
        ScoreboardTimeComponent,
        ScoreboardComponent,
        IconCustomComponent,
        SpeculativeLinkDirective,
        LcpCandidateDirective,
        NativePriceFormatterPipe,
        ToCssUrlPipe,
        DsTouchClickDirective,
    ],
})
export class HighlightsMarqueeModule {
    readonly highlightsMarqueeComponent = HighlightsMarqueeComponent;
    readonly marqueeOptionGroupComponent = OptionGroupComponent;
    readonly betNowButtonComponent = BetNowButtonComponent;
    readonly specialMarqueeBadgeComponent = SpecialMarqueeBadgeComponent;
}
